// Third-party packages
import {
	PATHS,
} from '@routes/paths';
import {
	lazy,
} from 'react';

// LAZY LOADING
const PageCompany = lazy(() =>
	import('@layouts/Pages/PageCompany').then((module) => ({
		default: module.PageCompany,
	})),
);
const Administrative = lazy(() =>
	import('@layouts/Pages/PageCompany/Administrative').then((module) => ({
		default: module.Administrative,
	})),
);
const Establishments = lazy(() =>
	import('@layouts/Pages/PageCompany/Establishments').then((module) => ({
		default: module.Establishments,
	})),
);
const Land = lazy(() =>
	import('@layouts/Pages/PageCompany/Land').then((module) => ({
		default: module.Land,
	})),
);
const Properties = lazy(() =>
	import('@layouts/Pages/PageCompany/Properties').then((module) => ({
		default: module.Properties,
	})),
);
const Transactions = lazy(() =>
	import('@layouts/Pages/PageCompany/Transactions').then((module) => ({
		default: module.Transactions,
	})),
);

export const COMPANY_ROOT_ROUTES = [
	{
		element: <PageCompany />,
		path: PATHS.COMPANY._ROOT,
	},
];

export const COMPANY_ADMINISTRATIVE_ROUTES = [
	{
		element: <Administrative />,
		path: PATHS.COMPANY.ADMINISTRATIVE,
	},
];

export const COMPANY_LANDS_ROUTES = [
	{
		element: <Land />,
		path: PATHS.COMPANY.LANDS,
	},
];

export const COMPANY_PROPERTIES_ROUTES = [
	...COMPANY_ADMINISTRATIVE_ROUTES,
	{
		element: <Properties />,
		path: PATHS.COMPANY.PROPERTIES,
	},
];

export const COMPANY_TRANSACTIONS_ROUTES = [
	{
		element: <Transactions />,
		path: PATHS.COMPANY.TRANSACTIONS,
	},
];

export const COMPANY_ESTABLISHMENTS_ROUTES = [
	{
		element: <Establishments />,
		path: PATHS.COMPANY.ESTABLISHMENTS,
	},
];

export const COMPANY_ROUTES = [
	...COMPANY_ADMINISTRATIVE_ROUTES,
	...COMPANY_ESTABLISHMENTS_ROUTES,
	...COMPANY_LANDS_ROUTES,
	...COMPANY_PROPERTIES_ROUTES,
	...COMPANY_ROOT_ROUTES,
	...COMPANY_TRANSACTIONS_ROUTES,
];
